// extracted by mini-css-extract-plugin
module.exports = {"from_tab_actions":"formTab_from_tab_actions__2Fl34"};